import React,{ Component } from 'react';

import {
  Row,
  Col,
  Button,
  FormText
} from 'reactstrap';

import DroppableFileInput from '../../../shared/components/DroppableFileInput';
import TextInput from '../../../shared/components/TextInput';
import HiddenInput from '../../../shared/components/HiddenInput';
import Form from '../../../shared/components/Form';
import ProgressEllipses from '../../../shared/components/ProgressEllipses';
import TutorialPopover from '../../../shared/components/TutorialPopover';
import DCMTagInput from '../../../shared/components/DCMTagInput';

import TrashSVG from '../../../shared/assets/trash.svg';

import { validateChooseEngagement } from '../../../shared/validators';

const OPTION_PLACEHOLDERS = ['Yes!','Not really...',"It's not my thing",'I hate it!'];

class CampaignChooseForm extends Component {
  constructor(){
    super();

    this.state = {
      validationMessages:{},
      isAddingChoice:false,
      image:null,
      isShowingPopover:false
    };
  }

  componentDidMount(){
    if(this.props.activeEngagementImageURL && this.props.activeEngagementImageFileName){
      this.setState({image:{
        id:this.props.activeEngagementImageId,
        fileName:this.props.activeEngagementImageFileName,
        large:this.props.activeEngagementImageURL
      }});
    }
  }

  componentWillReceiveProps(nextProps){
    if(!this.props.open && nextProps.open){
      window.setTimeout(() => this.setState({isShowingPopover:true}),500);
    }

    if(this.props.open && !nextProps.open){
      this.setState({isShowingPopover:false});
    }
  }

  handleAddChoiceClick(event){
    event.preventDefault();
    this.setState({isAddingChoice:true})
    this.props.onAddChoiceClick()
      .then(() => this.setState({isAddingChoice:false}))
      .catch((err) => this.setState({error:err}));
  }

  handleDeleteOptionClick(event,id){
    event.preventDefault();
    this.props.onDeleteChoiceClick(id);
  }

  handleSubmit(data){
    const image = this.state.image;

    data.tags = (data.firstTags || []);

    if(!data.options) data.options = [];

    if(image){
      data.firstImageURL = image.large;
      data.firstImageFileName = image.fileName;
      data.firstImageId = image.id;
    }

    const validationMessages = validateChooseEngagement(data);

    delete data.firstTags;
    delete data.secondTags;

    if(Object.keys(validationMessages).length > 0){
      this.setState({validationMessages:validationMessages});
      this.props.onSubmit(data);
    } else {
      this.setState({validationMessages:{}});
      this.props.onSubmit(data);
    }
  }

  render(){
    return (
      <Form 
        includeEmpty
        onSubmit={(data) => this.handleSubmit(data)}
      >
        <TutorialPopover
          open={this.state.isShowingPopover && this.props.isShowingTutorial}
          target={`ChooseTextInput_${this.props.activeEngagementId}`}
          onCloseClick={() => this.setState({isShowingPopover:false})}
          title='Multiple Choice Activity'
        >
          <p>
            Ask a question and consumers select from up to four choices.
            <br /><br />
            Suggestions:<br />
            Discover consumer preferences<br />
            Discover consumer demographics<br />
            Educate consumers
          </p>
        </TutorialPopover>
        <HiddenInput name='id' value={this.props.activeEngagementId} />
        <TextInput
          id={`ChooseTextInput_${this.props.activeEngagementId}`}
          label='Question'
          name='text'
          multiline
          defaultValue={this.props.activeEngagementText}
          placeholder='Do you like our latest flavor?'
          warning={this.state.validationMessages['text']}
          maxLength={100}
          showLengthIndicatorAtLength={15}
        />
        {this.props.activeEngagementOptions.map((o,index) => (
          <Row key={o.id}>
            <Col xs='11'>
              <HiddenInput
                name={`options[${index}][id]`}
                value={o.id}
              />
              <TextInput
                label={`Choice ${index + 1}`}
                name={`options[${index}][answer]`}
                defaultValue={o.answer}
                placeholder={OPTION_PLACEHOLDERS[index]}
                warning={this.state.validationMessages['options'] ? this.state.validationMessages['options'][index] : ''}
                maxLength={70}
              />
            </Col>
            <Col xs='1'>
              <br />
              <img
                src={TrashSVG}
                className='OptionTrashIcon'
                onClick={(e) => this.handleDeleteOptionClick(e,o.id)}
                alt='Trash'
              />
            </Col>
          </Row>
        ))}
        {this.props.activeEngagementOptions.length < 4 && (
          <div>
            <Button
              size='sm'
              onClick={(e) => this.handleAddChoiceClick(e)}
              disabled={this.state.isAddingChoice}
            >
              &nbsp;&nbsp;
              {this.state.isAddingChoice ?(<span>Adding Choice<ProgressEllipses /></span> ) :'Add Choice'}
              &nbsp;&nbsp;
            </Button>
            {this.state.validationMessages['allOptions'] && (
              <FormText className='DangerFeedback'>
                {this.state.validationMessages['allOptions']}
              </FormText>
            )}

          </div>
        )}
        <br />
        <DroppableFileInput
          label='Image'
          text='Upload image'
          name='firstImage'
          fileType='image'
          cropperAspectRatio={4/3}
          onChange={(image) => this.setState({image:image})}
          warning={this.state.validationMessages['firstImageURL']}
          existingFileName={this.props.activeEngagementImageFileName}
          existingFileURL={this.props.activeEngagementImageURL}
          tooltip={(
            <span>Use a large crisp 4x3 image.<br />We recommend 800px by 600px.  <br />Maximum file size of 2MB.</span>
          )}
        />
        <DCMTagInput 
          type='first' 
          name='firstTags'
          defaultValue={this.props.activeEngagementFirstTags}
          warning={this.state.validationMessages['firstTags']}
        />
        <br />
        <Button size='sm' color='primary' type='submit'>
          &nbsp;&nbsp;Save&nbsp;&nbsp;
        </Button>
      </Form>
    )
  }
}
CampaignChooseForm.defaultProps = {
  onDeleteChoiceClick:() => {},
  onAddChoiceClick:() => {},
  isShowingTutorial:true,
  showSuperadminFeatures:false
};

export default CampaignChooseForm;



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignCreation/components/CampaignChooseForm.js